import { environment } from '../../environments/environment';

export const locale = {
    lang: 'es',
    data: {
        APP: {
            TITLE: environment.titleBase,
            SOCKET: {
                DISCONNECT: 'Has sido desconectado',
                OFFLINE: 'No tienes conexión a internet',
                RECONNECTING: 'Reconectando...',
                RECONNECT: 'Reconectar',
            },
            PUSH_NOTIFICATION: {
                REQUEST_PERMISSION: {
                    TITLE: 'Activa las notificaciones',
                    MESSAGE: 'Activa las notificaciones del navegador para recibir alertas.',
                },
                BUTTONS: {
                    ALLOW: 'Habilitar',
                    CANCEL: 'Cancelar',
                },
            },
            MODAL: {
                FEATURES: {
                    TITLE: 'Novedades',
                    BUTTONS: {
                        READ_LATER: 'Leer más tarde',
                        OK: 'Ok, entendido',
                        READ_ALL: 'Leer todo',
                    },
                },
                SEARCH_ORDER: {
                    TITLE: 'Buscar pedido',
                    BUTTONS: {
                        SEARCH: 'Buscar',
                        CANCEL: 'Cancelar',
                    },
                },
                PEOPLE: {
                    TITLE: 'Buscar persona',
                    BUTTONS: {
                        CANCEL: 'Cancelar',
                    },
                },
                CHUNK_ERROR: {
                    TITLE: 'Actualización del sistema',
                    DESCRIPTION: 'Se ha producido un error al cargar una parte de la aplicación. Por favor, recargue la página para continuar.',
                    BUTTONS: {
                        CONFIRM: 'Recargar',
                    }
                },
                LABORATORY_CHANGED: {
                    TITLE: 'Sesión modificada',
                    DESCRIPTION: 'Detectamos que el laboratorio o la cuenta conectada ha cambiado.<br>Recargue la página para continuar.',
                    BUTTONS: {
                        CONFIRM: 'Recargar',
                    }
                },
            },
        },
    },
};
